<template>
  <div class="detect_create">
    <div class="detect_create_top">
      <div class="detect_create_top_message">
        <div class="detect_create_top_message_item">
          <span class="detect_create_top_message_item_title" style="width: 110px;">
            <span style="color: #FF0000;">*</span>
            盘点任务名：
          </span>
          <el-input v-model="checkName" placeholder="请输入清查单名称" style="width: 520px;"></el-input>
        </div>
        <div class="detect_create_top_message_item">
          <span class="detect_create_top_message_item_title" style="width: 110px;">
            <span style="color: #FF0000;">*</span>
            创建时间：
          </span>
          <el-date-picker
            v-model="startTime"
            type="date"
            placeholder="选择开始日期"
            format="yyyy/MM/dd"
            value-format="yyyy-MM-dd"
            style="width: 230px;">
          </el-date-picker>
          <span style="margin: 0 20px; line-height: 38px;">至</span>
          <el-date-picker
            v-model="endTime"
            type="date"
            placeholder="选择结束日期"
            format="yyyy/MM/dd"
            value-format="yyyy-MM-dd"
            style="width: 230px;">
          </el-date-picker>
        </div>
        
      </div>

      <div class="detect_create_top_message">
        
        <!-- <div class="detect_create_top_message_item">
          <span class="detect_create_top_message_item_title">
            <span style="color: #FF0000;">*</span>
            选择盘点人：
          </span>
          <el-select 
            v-model="checkUserChird" 
            :fetch-suggestions="getOutUserList"
            multiple 
            placeholder="请选择盘点人" 
            style="width: 520px;" 
            @change="checkUserChirdChange" 
            @remove-tag="clearUserChird">
            <el-option
              v-for="item in outAllUserList"
              
              :key="item.userId"
              :label="item.username"
              :value="item.userId">
            </el-option>
          </el-select>
        </div> -->
        <div class="detect_create_top_message_item">
          <span class="detect_create_top_message_item_title" style="width: 155px">
            <span style="color: #FF0000;">*</span>
            筛选人员：
          </span>
          <el-input 
            v-model="searchName" 
            placeholder="请输入需要筛选的人员姓名"
            @blur="getOutUserList">
          </el-input>
        </div>
      </div>

      <div class="detect_create_top_message">
        <div class="detect_create_top_message_item">
          <span class="detect_create_top_message_item_title">
            <span style="color: #FF0000;">*</span>
            选择审核人：
          </span>
          <el-select v-model="checkUser" placeholder="选择审核人" style="width: 520px;" @change="checkUserChange">
            <el-option
              v-for="item in outAllUserList"
              :key="item.userId"
              :label="item.username"
              :value="item.userId">
            </el-option>
          </el-select>
        </div>
        
        <div class="detect_create_top_message_item">
          <span class="detect_create_top_message_item_title">
            <span style="color: #FF0000;">*</span>
            选择盘点人：
          </span>
          <el-select 
            v-model="checkUserChird" 
            :fetch-suggestions="getOutUserList"
            multiple 
            placeholder="请选择盘点人" 
            style="width: 520px;" 
            @change="checkUserChirdChange" 
            @remove-tag="clearUserChird">
            <el-option
              v-for="item in outAllUserList"
              
              :key="item.userId"
              :label="item.username"
              :value="item.userId">
            </el-option>
          </el-select>
        </div>
      </div>

      <div class="detect_create_top_message" style="padding-bottom: 30px;">
        <div class="detect_create_top_message_item">
          <span class="detect_create_top_message_item_title" style="width: 110px;">
            <span style="color: #F3F3F3;">*</span>
            清查备注：
          </span>
        <el-input
          type="textarea"
          :rows="2"
          placeholder="请输入内容"
          v-model="textarea"
          style="width: 1000px;">
        </el-input>
        </div>
      </div>

      <div class="detect_create_top_message" style="padding-bottom: 30px;">
        <div class="detect_create_top_message_item">
          <span class="detect_create_top_message_item_title" style="width: 110px;">
            <span style="color: #FF0000;">*</span>
            分派子任务：
          </span>
          <el-table
            :data="outUserList"
            style="width: 1300px">
            <el-table-column
              type="index"
              width="100"
              label="序列">
            </el-table-column>
            <el-table-column
              prop="username"
              label="清查人"
              width="180">
            </el-table-column>
            <el-table-column
              label="清查子任务"
              prop="placeList">
              <template slot-scope="scope">
                <el-select 
                  v-model="scope.row.checkIdList" 
                  multiple 
                  placeholder="请分配清查任务" 
                  style="width: 520px;"
                  @change="checkPlaceIdSelectChange(scope.row)"
                  @remove-tag="clearPlace($event, scope.row)"
                  @focus = "blurChange">
                  
                  <el-option
                    v-for="item in placeList"
                    :key="item.taskId"
                    :label="item.taskName + '/数量'+ item.taskCount"
                    :value="item.taskId">
                  </el-option>
                </el-select>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>

      <el-button 
        type="primary"
        @click="submitDeteceData"
        style="height: 80px; width: 200px; font-size: 24px; margin: 60px 0 50px 1250px;">
        提交清查单
      </el-button>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import Cookies from "js-cookie";
  import { Loading } from 'element-ui';
  export default {
    name: 'DetectCreate',
    data() {
      return {
        checkName: '',
        outAllUserList: [],
        outUserList: [],
        checkUser: '',
        checkUserChird: [],
        checkUserChirdLength: 1,
        checkPlace: [],
        placeList: [],
        checkPlaceList: [],
        deleteId: '',
        startTime: '',
        endTime: '',
        textarea: '',
        blurChangeId: [],
        changeId: [],
        searchName: '',
      }

    },

    methods: {
      //获取清查人员
      getOutUserList() {
        let params = {
          name: this.searchName,
          // name: '',
        }
        this.axios({
          method: 'GET',
          url: '/public/getUserListByName',
          params:params,
        }).then((res)=>{
          if(res.data.code == 200) {
            console.log(res)
            this.outAllUserList = res.data.data
            // this.outUserList = this.outAllUserList
          } else {
            this.$message.error(res.data.message)
          }
        })
      },
      //获取所有人员
      // getAllUserList() {
      //   let params = {
      //     // name: this.searchName,
      //     // name: '',
      //   }
      //   this.axios({
      //     method: 'GET',
      //     url: '/public/getUnitUsers',
      //     params:params,
      //   }).then((res)=>{
      //     if(res.data.code == 200) {
      //       console.log(res)
      //       this.outAllUserList = res.data.data
      //       // this.outUserList = this.outAllUserList
      //     } else {
      //       this.$message.error(res.data.message)
      //     }
      //   })
      // },
      //获取清查任务区域
      getSortByPlace() {
        let ids = this.blurChangeId
        // console.log(ids)
        //如果子任务选择框进行了选择
        // if(idList != undefined) {
        //   ids.push(idList)
        // }
        // let originIds = [].concat(this.deleteId)
        this.axios({
          method: 'GET',
          url: '/check/sortByPlace',
          params: {
            ids: ids + '',
            // originIds: originIds + '' 
          },  
        }).then((res)=>{
          if(res.data.code == 200) {
            this.placeList = res.data.data
            //调用对表格渲染数据改造的方法
            this.changeUserList(res.data.data, index)
            this.deleteId = ''
          } else {
            this.$message.error(res.data.message)
          }
        })
      },

      //改造清查人数组
      changeUserList(placeList, index) {
        console.log(index)
         
        if(index === undefined) {
          if(this.outUserList[0] !== undefined) {
            let add1 = {placeList: placeList}
            let add2 = {checkIdList: []}
            let add3 = {taskNum: 0}
            let add4 = {index: 0}
            this.outUserList.forEach(item => {
              add4.index += 1
              Object.assign(item, add1, add2, add3, add4)
            })
            console.log(this.outUserList)
          }
        } else {
          
        }
      },

      //筛选清查人员
      getOutUserSearchList() {
        // let authorization = Cookies.get("Authorization");
        let ids = [].concat(this.checkUser)
        this.axios({
          method: 'GET',
          url: '/public/showOut',
          params: {
            ids: ids + ''
          },
        }).then((res)=>{
          console.log(res)
          if(res.data.code == 200) {
            this.outUserList = res.data.data
            this.getSortByPlace()
          } else {
            this.$message.error(res.data.message)
          }
        })
      },

      //清查人名单发生变化
      checkUserChange() {
        // this.getOutUserSearchList()
      },
      //清查范围发生变换
      checkPlaceChange(i) {
        // console.log(i)
        // this.checkIdList.push(i)
        // this.getSortByPlace()
      },

      clearPlace(val, scope) {
        // this.blurChangeId.forEach((item, i) => {
        //   item === val ? this.blurChangeId.splice(i , 1) : ''
        // })
        // console.log(this.blurChangeId)
        // this.getSortByPlace()
      },

      //选择框id发生变化时
      checkPlaceIdSelectChange(val) {
        console.log(val)
        this.changeId = []
        this.changeId.push(val.checkIdList)
        console.log(this.changeId)
        // this.getSortByPlace()
      },
      //失去焦点
      blurChange() {
        console.log(this.changeId)
        // Array.prototype.push.apply(this.blurChangeId,this.changeId);
        this.changeId.forEach(item => {
          this.blurChangeId.push(item)
        })
        // console.log(this.blurChangeId)
        this.getSortByPlace()
      },


      checkUserChirdChange(data) {
        // let length = data.length
        // console.log(data.length)
        // console.log(data.length === this.checkUserChirdLength)
        // if(data.length === this.checkUserChirdLength) {
        //   this.outAllUserList.forEach(item => {
        //   // console.log(item)
        //     if(item.userId == data[data.length - 1]) {
        //       this.outUserList.push(item)
        //     }
        //   })
        //   this.checkUserChirdLength += 1
        // }
        this.axios({
          method: 'GET',
          url: '/public/getUserListById',
          params: {
            uids: data + '',
          },
        }).then((res)=>{
          console.log(res)
          if(res.data.code == 200) {
            this.outUserList = res.data.data
            // this.getSortByPlace()
          } else {
            this.$message.error(res.data.message)
          }
        })
      },
      clearUserChird(data) {
        console.log(data)
        // this.outUserList = []
      },
      //提交清查任务
      submitDeteceData() {
        let submitData = {
          hyCheck: {
            checkName: this.checkName,
            checkSortType: '1',
            checkUserId: this.checkUser,
            createDate: this.startTime,
            endDate: this.endTime,
          },
          hyCheckTasks: [],
        }
        this.outUserList.forEach(item => {
          console.log(item.checkIdList[0])
          
          if(item.checkIdList[0] !== undefined) {
            let pushData = {
              // taskId: item.id,
              palceIdList: item.checkIdList,
              taskId:item.userId,
              taskName: item.username + '清查子任务',
              taskUserId: item.userId,
              taskCheckerId: this.checkUser,
              taskCount:100,
              endDate:  this.endTime,
            }
            submitData.hyCheckTasks.push(pushData)
          }
        })
        let loadingInstance = Loading.service({
          lock: 'loading',
          text:'提交中请稍后....'
        });
        this.axios({
          method: 'POST',
          url: '/check/add',
          data: submitData,
          Headers: {
            'Content-Type':'application/json;charset=UTF-8'
          },
        }).then(res => {
          console.log(res)
          if(res.data.code == 200) {
            this.$message.success('创建清查任务成功')
            this.$nextTick(() => { 
              loadingInstance.close();
            });
          } else {
            this.$message.error(res.data.message)
            this.$nextTick(() => { 
              loadingInstance.close();
            });
          }
        })
      },
    },
    

    created() {      
      this.getOutUserList()
      this.getSortByPlace()
      this.getAllUserList()
    }
  }
</script>

<style lang="less" >
  .detect_create {
    background-color: #F3F3F3;
    border: 10px #fff solid;

    .detect_create_top {
      display: flex;
      flex-direction: column;

      .detect_create_top_message {
        display: flex;
        justify-content: start;
        margin: 10px 0 0 30px;

        .detect_create_top_message_item {
          margin: 30px 80px 0 0;
          display: flex;
          justify-content: start;

          .detect_create_top_message_item_title {
            line-height: 38px;
          }
        }
      }
    }
  }
</style>
<!-- <template>
  <div>
    <div v-if="New == 1">
      <CheckCreateNew></CheckCreateNew>
    </div>

    <div v-if="New == 2">
      <CheckCreateNewTwo ref="hh"></CheckCreateNewTwo>
    </div>

    <div v-if="New == 3">
      <CheckCreateNewThree></CheckCreateNewThree>
    </div>
  </div>
</template>

<script>
  import CheckCreateNew from "./CheckCreateNew.vue"
  import CheckCreateNewTwo from "./CheckCreateNewTwo.vue"
  import CheckCreateNewThree from "./CheckCreateNewThree.vue"
  export default {
     name: 'CheckIndex',
     components:{
       CheckCreateNew,
       CheckCreateNewTwo,
       CheckCreateNewThree
     },
     data () {
       return {
          New:1,

          searchDTO:{
            propertyName:"",
            propertyCode:"",
            propertyTypeId:"",
            placeId:"",
            ownerName:"",
            unitId:"",
            propertyState:"",
          },


          taskName:'',
          taskData:[{
            taskId:'',
            taskName:'',
            taskUserId:'',
            taskCheckerId:'',
            taskCount:'',
            endDate:'',
          }]
        };
     },
     methods: {
		// 保存创建盘点单任务的所有页面
		// 通过改变page切换页面
        Change(val){
          this.New = val
          if(this.New == 2){

            this.$nextTick(() => {
            	this.$refs.hh.showCData()
            })



          }
        }
     }
   }


</script>

<style>
</style> -->



// WEBPACK FOOTER //
// src/components/Check/CheckIndex.vue